import EventEmitter from 'events';
import { useEffect, useState } from 'react';
import { useUserContextPreferences } from '../../../../../../hooks/useUserContextPreferences';
import {
  DynamicOptionsSelectorsCreatorActionTypes,
  UseDynamicOptionsSelectorsCreatorProps,
} from './useDynamicOptionsSelectorsCreator.types';

const myEventEmitter = new EventEmitter();

export const resetFiltersCreatedByCreator = () => {
  myEventEmitter.emit(DynamicOptionsSelectorsCreatorActionTypes.RESET_FILTERS);
};

export const clearFiltersCreatedByCreator = () => {
  myEventEmitter.emit(DynamicOptionsSelectorsCreatorActionTypes.CLEAR_FILTERS);
};

export const resetToDefaultValuesFiltersCreatedByCreator = () => {
  myEventEmitter.emit(DynamicOptionsSelectorsCreatorActionTypes.RESET_TO_DEFAULT_VALUES);
};

function useDynamicOptionsSelectorsCreator({ list }: UseDynamicOptionsSelectorsCreatorProps) {
  const { getDefaultFiltersToList } = useUserContextPreferences();
  const defaultFilters = list ? getDefaultFiltersToList(list) : null;

  const [counterToReset, setCounterToReset] = useState(0);
  const [counterToClearAll, setCounterToClearAll] = useState(0);
  const [counterToResetToDefaultValues, setCounterToResetToDefaultValues] = useState(0);

  useEffect(() => {
    const handleEvent = () => {
      setCounterToReset((prevCount) => prevCount + 1);
    };

    myEventEmitter.on(DynamicOptionsSelectorsCreatorActionTypes.RESET_FILTERS, handleEvent);
    return () => {
      myEventEmitter.removeListener(
        DynamicOptionsSelectorsCreatorActionTypes.RESET_FILTERS,
        handleEvent,
      );
    };
  }, []);

  useEffect(() => {
    const handleEvent = () => {
      setCounterToClearAll((prevCount) => prevCount + 1);
    };

    myEventEmitter.on(DynamicOptionsSelectorsCreatorActionTypes.CLEAR_FILTERS, handleEvent);
    return () => {
      myEventEmitter.removeListener(
        DynamicOptionsSelectorsCreatorActionTypes.CLEAR_FILTERS,
        handleEvent,
      );
    };
  }, []);

  useEffect(() => {
    const handleEvent = () => {
      setCounterToResetToDefaultValues((prevCount) => prevCount + 1);
    };

    myEventEmitter.on(
      DynamicOptionsSelectorsCreatorActionTypes.RESET_TO_DEFAULT_VALUES,
      handleEvent,
    );
    return () => {
      myEventEmitter.removeListener(
        DynamicOptionsSelectorsCreatorActionTypes.RESET_TO_DEFAULT_VALUES,
        handleEvent,
      );
    };
  }, []);

  return { counterToReset, counterToClearAll, counterToResetToDefaultValues, defaultFilters };
}

export default useDynamicOptionsSelectorsCreator;
